// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".anketa-wrap{max-width:600px!important;display:flex;flex-direction:column;align-items:center}@media (max-width:500px){.param-title,.param-value{font-size:14px!important}.text-title{font-size:16px!important}}", ""]);
// Exports
module.exports = exports;
